export default __webpack_public_path__ + "static/media/Stage3_wrong.4c16799d.svg";